import { render, staticRenderFns } from "./UserBalanceDeduction.vue?vue&type=template&id=cf2f839c&"
import script from "./UserBalanceDeduction.vue?vue&type=script&lang=js&"
export * from "./UserBalanceDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports